import { ref } from '@vue/composition-api';

export default (root) => {
  const clicksToBuyOnlineAmount = ref(1);
  const clicksCallToProviderAmount = ref(1);

  const increaseClicksBuyOnline = () => {
    clicksToBuyOnlineAmount.value += 1;
  };

  const increaseClicksCallToProvider = () => {
    clicksCallToProviderAmount.value += 1;
  };

  const resetClicksToBuyOnlineAmount = () => {
    clicksToBuyOnlineAmount.value = 1;
  };

  const resetClicksCallToProviderAmount = () => {
    clicksCallToProviderAmount.value = 1;
  };

  const internalTrackerResultsPage = (eventKey, eventValue) => {
    try {
      return root.$api.resultsPageInteraction({
        eventKey,
        eventValue,
      });
    } catch (e) {
      console.log(e);
    }
  };
  return {
    internalTrackerResultsPage,
    clicksToBuyOnlineAmount,
    clicksCallToProviderAmount,
    increaseClicksBuyOnline,
    increaseClicksCallToProvider,
    resetClicksToBuyOnlineAmount,
    resetClicksCallToProviderAmount,
  };
};
